import React from "react";
import JumboLayout from "@jumbo/components/JumboLayout";
import Header from "../shared/headers/Header";
import Sidebar from "../shared/sidebars/Sidebar";
import Footer from "../shared/footers/Footer";
import useJumboLayout from "@jumbo/hooks/useJumboLayout";
import JumboCustomizer from "../../shared/JumboCustomizer/JumboCustomizer";
import JumboCustomizerButton from "../../shared/JumboCustomizer/JumboCustomizerButton";
import useJumboHeaderTheme from "@jumbo/hooks/useJumboHeaderTheme";
import useJumboLayoutSidebar from "@jumbo/hooks/useJumboLayoutSidebar";
import useJumboTheme from "@jumbo/hooks/useJumboTheme";
import {
  SIDEBAR_STYLES,
  SIDEBAR_VARIANTS,
  SIDEBAR_VIEWS,
} from "@jumbo/utils/constants";
import { headerTheme as theme4 } from "../../themes/header/theme4";
import { headerTheme as defaultTheme } from "../../themes/header/default";
import useApp from "../../hooks/useApp";
import layoutConfig from "./layoutConfig";
import { useMediaQuery } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import CampaignFiltersCustomizer from "app/shared/JumboCustomizer/CampaignFiltersCustomizer";
import AdvertiserFiltersCustomizer from "app/shared/JumboCustomizer/AdvertiserFiltersCustomizer";
import PublisherFiltersCustomizer from "app/shared/JumboCustomizer/PublisherFiltersCustomizer";
import SegmentFiltersCustomizer from "app/shared/JumboCustomizer/SegmentFiltersCustomizer";
import TargetingGroupFiltersCustomizer from "app/shared/JumboCustomizer/TargetingGroupFiltersCustomizer";
import UserFiltersCustomizer from "app/shared/JumboCustomizer/UserFiltersCustomizer";
import AccountFiltersCustomizer from "app/shared/JumboCustomizer/AccountFiltersCustmozier";
import AudienepixelFiltersCustomizer from "app/shared/JumboCustomizer/AudiencepixelFilterCustmozier";

const VerticalDefault = ({ children }) => {
  const { setJumboLayoutOptions } = useJumboLayout();
  const { headerTheme, setHeaderTheme } = useJumboHeaderTheme();
  const location = useLocation();
  const { theme } = useJumboTheme();
  const appBarBgColor =
    headerTheme.components?.MuiAppBar?.styleOverrides?.root?.background;
  const { sidebarOptions } = useJumboLayoutSidebar();
  const appData = useApp();

  React.useEffect(() => {
    setJumboLayoutOptions(layoutConfig);
  }, []);

  const {
    globalAccountsList,
    globalAdvertisersList,
    globalCampaignsList,
    globalBannersList,
    authUserData,
    globalPublishersList,
    globalCompaniesList,
    globalUsersList,
  } = useSelector((state) => state.CommonReducer);
  React.useEffect(() => {
    if (
      appBarBgColor === "#F5F7FA" &&
      sidebarOptions.style === SIDEBAR_STYLES.CLIPPED_UNDER_HEADER
    ) {
      setHeaderTheme({ ...theme, ...theme4 });
      appData.setAppState({
        prevHeaderBgColor: theme?.mode === "dark" ? "#222D45" : "#F5F7FA",
      });
    } else if (
      appData.prevHeaderBgColor &&
      appData.prevHeaderBgColor === "#F5F7FA"
    ) {
      setHeaderTheme({ ...theme, ...defaultTheme });
    }
  }, [sidebarOptions.style]);

  console.log("VerticalDefault:", location.pathname);

  return (
    <JumboLayout
      header={<Header />}
      sidebar={<Sidebar />}
      footer={<Footer />}
      headerSx={{
        height: 60,
      }}
    >
      {children}

      {location.pathname == "/home/reporting" && (
        <>
          {(authUserData.is_sys_admin == "1" ||
            globalAccountsList.length > 0 ||
            authUserData.is_sys_admin == "1" ||
            globalAdvertisersList.length > 0 ||
            authUserData.is_sys_admin == "1" ||
            globalCampaignsList.length > 0) &&
            authUserData?.user_assoc_profiles?.includes("advertiser") && (
              <>
                <JumboCustomizerButton />
                <JumboCustomizer />
              </>
            )}
        </>
      )}
      {location.pathname == "/targeting/campaigns" && (
        <>
          {/* {((authUserData.is_sys_admin == "1" ||
            globalAccountsList.length > 1) || (authUserData.is_sys_admin == "1" ||
              globalAdvertisersList.length > 1) || (authUserData.is_sys_admin == "1" ||
                globalCampaignsList.length > 1)) && <><JumboCustomizerButton top={85} />
              <CampaignFiltersCustomizer /></>} */}
          <JumboCustomizerButton top={85} />
          <CampaignFiltersCustomizer />
        </>
      )}
      {location.pathname == "/advertiser/manageadvertisers" && (
        <>
          {(authUserData.is_sys_admin == "1" ||
            globalAccountsList.length > 1 ||
            authUserData.is_sys_admin == "1" ||
            globalAdvertisersList.length > 1) && (
            <>
              <JumboCustomizerButton top={85} />
              <AdvertiserFiltersCustomizer />
            </>
          )}
        </>
      )}
      {location.pathname == "/publisher/managepublishers" && (
        <>
          {(authUserData.is_sys_admin == "1" ||
            globalAccountsList.length > 1 ||
            authUserData.is_sys_admin == "1" ||
            globalPublishersList.length > 1) && (
            <>
              <JumboCustomizerButton top={85} />
              <PublisherFiltersCustomizer />
            </>
          )}
        </>
      )}
      {location.pathname == "/system/manageusers" && (
        <>
          {(authUserData.is_sys_admin == "1" ||
            globalCompaniesList.length > 1) && (
            <>
              <JumboCustomizerButton top={85} />
              <UserFiltersCustomizer />
            </>
          )}
        </>
      )}
      {location.pathname == "/advertiser/audiencepixels" && (
        <>
          {(authUserData.is_sys_admin == "1" ||
            globalCompaniesList.length > 1) && (
            <>
              <JumboCustomizerButton top={85} />
              <AudienepixelFiltersCustomizer />
            </>
          )}
        </>
      )}

      {location.pathname == "/system/manageaccounts" && (
        <>
          {(authUserData.is_sys_admin == "1" ||
            globalCompaniesList.length > 1) && (
            <>
              <JumboCustomizerButton top={85} />
              <AccountFiltersCustomizer />
            </>
          )}
        </>
      )}
      {location.pathname == "/audience/segments" && (
        <>
          {(authUserData.is_sys_admin == "1" ||
            globalAccountsList.length > 1) && (
            <>
              <JumboCustomizerButton top={85} />
              <SegmentFiltersCustomizer />
            </>
          )}
          {/* <JumboCustomizerButton top={85} />
          <SegmentFiltersCustomizer /> */}
        </>
      )}
      {location.pathname == "/targeting/targetinggroups" && (
        <>
          {(authUserData.is_sys_admin == "1" ||
            globalAccountsList.length > 1) && (
            <>
              <JumboCustomizerButton top={85} />
              <TargetingGroupFiltersCustomizer />
            </>
          )}
        </>
      )}
    </JumboLayout>
  );
};

export default VerticalDefault;
